import React,{useEffect,useState} from 'react';
import { Container, Card } from 'react-bootstrap';
import { db } from '../FireBase';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';

const ShippingPolicy = () => {


    const [contactInfo, setContactInfo] = useState({});
    useEffect(() => {
        fetchContactInfo();
      }, []);
    
      const fetchContactInfo = async () => {
        const docRef = doc(db, 'settings', 'contact');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContactInfo(docSnap.data());
        }
      };
  return (
    <Container className="p-2 " style={{marginBottom:'40px'}}>
      <Card className="shadow rounded-4 p-4 border-0">
        <Card.Body>
          <h2 className="mb-4 text-center">Shipping policy</h2>

          <section className="mb-4">
            <h5>Shipping and Delivery</h5>
            <p style={{textAlign:'justify'}}>
                Natural delight is committed to excellence and the full satisfaction of our customers. We proudly offer shipping services and are doing everything in our power to get your order to you as soon as possible. Please consider any holidays that might impact delivery times. We also offer same-day dispatch.
            </p>
          </section>
          <section className="mb-4">
            <h5>1.Shipping & Delivery</h5>
            <p style={{textAlign:'justify'}}>
            All orders for our products are shipped and delivered within 0-1 business days. Orders are not shipped or delivered on weekends or holidays. If we are experiencing a high volume of orders, shipments may be delayed by a few days. Please allow additional days in transit for delivery. If there will be a significant delay in the shipment of your order, we will contact you via email.
            </p>
          </section>

          <section className="mb-4">
            <h5>2.Wrong Address Disclaimer</h5>
            It is the responsibility of the customers to make sure that the shipping address entered is correct. Please contact us immediately if you believe you have provided an incorrect shipping address.
          </section>

          <section className="mb-4">
            <h5>3.Undeliverable Orders</h5>
            <p style={{textAlign:'justify'}}>
            Orders that are returned to us as undeliverable because of incorrect shipping information are subject to a restocking fee to be determined by us.
            </p>
          </section>

          <section className="mb-4">
            <h5>4.Lost/Stolen Packages</h5>
            <p style={{textAlign:'justify'}}>
            Natural delight is not responsible for lost or stolen packages. If your tracking information states that your package was delivered to your address and you have not received it, please report it to the local authorities.
            </p>
          </section>

          <section className="mb-4">
            <h5>5.Return Request Days</h5>
            <p style={{textAlign:'justify'}}> 
            Natural delight allows you to return its items within a period of 15 days. Kindly be advised that the items should be returned unopened and unused.
            </p>
          </section>

          <section className="mb-4">
            <h5>6.Out of Stock Item Process</h5>
            <p style={{textAlign:'justify'}}> 
            Natural delight has the following options in the event there are items which are out of stock: end available items first and send remaining items when items arrive back in stock.
            </p>
          </section>

          <section className="mb-4">
            <h5>7.Import Duty and Taxes</h5>
            <p style={{textAlign:'justify'}}> 
            When dealing with Natural delight, you have the option of pre-paying whereby we will include the amount in the price of the order.
            </p>
          </section>

          <section className="mb-4">
            <h5>8.Acceptance</h5>
            <p style={{textAlign:'justify'}}> 
            By accessing our site and placing an order, you have willingly accepted the terms of this Shipping Policy.
            </p>
          </section>


          <section className="mb-4">
            <h5>9. Exchange Policy</h5>
            <p style={{textAlign:'justify'}}> 
            We do not currently offer exchanges. Customers can return the original item and place a new order for the desired product.
            </p>
          </section>

          <section className="mb-4">
            <h5>9. Changes to Privacy Policy</h5>
            <p style={{textAlign:'justify'}}> 
            We reserve the right to update this Privacy Policy. Any changes will be posted on this page, and the revised date will be indicated.
            </p>
          </section>

          <section className="mb-4">
            <h5>10. Contact Information</h5>
            <p style={{whiteSpace: 'pre-wrap',textAlign:'justify' }}>
            <strong>Address:</strong><br />{contactInfo.address}</p>
            <p style={{textAlign:'justify'}}> 
            Mail:<a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a><br/>
            Phone:<a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a><br/>
            
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ShippingPolicy;
